import {
  IconChevronsUp,
  IconCircleCheck,
  IconCircleDashed,
  IconInfoCircle,
  IconPlaystationX,
} from '@tabler/icons-react'

import { PlatformActionStatus } from 'types/api.graphql'

export const ACTION_STATUS = {
  [PlatformActionStatus.ToDo]: {
    label: 'To do',
    value: PlatformActionStatus.ToDo,
    icon: <IconInfoCircle size={16} />,
    variant: 'warning' as const,
  },
  [PlatformActionStatus.InProgress]: {
    label: 'In progress',
    value: PlatformActionStatus.InProgress,
    icon: <IconCircleDashed size={16} />,
    variant: 'info' as const,
  },
  [PlatformActionStatus.WaitingReview]: {
    label: 'Waiting review',
    icon: <IconCircleCheck size={16} />,
    variant: 'warning' as const,
    category: 'Open',
  },
  [PlatformActionStatus.Complete]: {
    label: 'Completed',
    value: PlatformActionStatus.Complete,
    icon: <IconChevronsUp size={16} />,
    variant: 'success' as const,
  },
  [PlatformActionStatus.CantDo]: {
    label: "Can't do",
    value: PlatformActionStatus.CantDo,
    icon: <IconPlaystationX size={16} />,
    variant: undefined,
  },
}

export const CLOSE_ACTION_STATUSES = [
  PlatformActionStatus.Complete,
  PlatformActionStatus.CantDo,
]

export const NON_CLOSEABLE_ACTION_STATUSES = Object.keys(ACTION_STATUS).reduce(
  (acc, status: PlatformActionStatus) => {
    if (CLOSE_ACTION_STATUSES.includes(status)) {
      return acc
    }
    return { ...acc, [status]: ACTION_STATUS[status] }
  },
  {}
)

export const ACTION_STATUSES_TRIGGER_VALIDATION = [
  PlatformActionStatus.WaitingReview,
  PlatformActionStatus.Complete,
  PlatformActionStatus.CantDo,
]

export enum PlatformActionTab {
  Todo = 'To do',
  InProgress = 'In progress',
  WaitingReview = 'Waiting review',
  Completed = 'Completed',
  CantDo = "Can't do",
  All = 'All',
}

export const ACTION_STATUS_TO_TAB: Record<
  PlatformActionStatus & 'ALL',
  keyof typeof PlatformActionTab
> = {
  TO_DO: 'Todo',
  IN_PROGRESS: 'InProgress',
  WAITING_REVIEW: 'WaitingReview',
  COMPLETE: 'Completed',
  CANT_DO: 'CantDo',
  ALL: 'All',
}

export const ACTION_TAB_TO_STATUS: Record<
  keyof typeof PlatformActionTab,
  PlatformActionStatus
> = {
  Todo: PlatformActionStatus.ToDo,
  InProgress: PlatformActionStatus.InProgress,
  WaitingReview: PlatformActionStatus.WaitingReview,
  Completed: PlatformActionStatus.Complete,
  CantDo: PlatformActionStatus.CantDo,
  All: undefined,
}
